import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChapterHeader, Reveal } from "./Reveal";

const FRAMES = [
  { src: "/images/karadjordjeva.jpg", label: "Karađorđeva u lepinji", alt: "Karađorđeva sa prilozima u lepinji" },
  { src: "/images/porcija.jpg", label: "Porcija sa pomfritom", alt: "Porcija roštilja sa pomfritom i salatom" },
  { src: "/images/rostilj.jpg", label: "Sveže meso na žaru", alt: "Sveže meso spremno za roštilj" },
];

export const Gallery = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const yBand = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  const offsets = [
    useTransform(scrollYProgress, [0, 1], [40, -40]),
    useTransform(scrollYProgress, [0, 1], [90, -30]),
    useTransform(scrollYProgress, [0, 1], [60, -70]),
  ];

  return (
    <section id="galerija" ref={ref} className="relative py-28 sm:py-40 bg-paper2 border-y border-black/5 overflow-hidden" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <ChapterHeader
          number="05"
          title={<>Sa žara, <span className="text-leaf">u kadar</span></>}
          sub="Pravi kadrovi iz naše kuhinje — bez filtera i bez uljepšavanja. Ovako izgleda kad se radi do jaja."
        />
      </div>

      <div className="relative h-[42vh] sm:h-[58vh] overflow-hidden my-4 sm:my-8" data-testid="gallery-parallax-band">
        <motion.img
          src="/images/rostilj.jpg"
          alt="Meso na roštilju"
          style={{ y: yBand }}
          className="absolute -top-[12%] left-0 w-full h-[124%] object-cover"
        />
        <div className="absolute inset-0 bg-ink/40" />
        <p className="absolute inset-0 flex items-center justify-center font-display font-black uppercase text-bone text-3xl sm:text-5xl lg:text-7xl tracking-tight text-center px-6">
          Sveže. Vrelo. <span className="text-chili">&nbsp;Do jaja.</span>
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid sm:grid-cols-3 gap-6 items-start mt-14 sm:mt-20">
        {FRAMES.map((f, i) => (
          <motion.figure
            key={f.label}
            style={{ y: offsets[i] }}
            data-testid={`gallery-frame-${i}`}
            className={`group relative overflow-hidden rounded-[1.75rem] border-2 ${
              i % 2 ? "border-leaf/35" : "border-ember/25"
            } shadow-[0_30px_60px_-25px_rgba(27,21,18,0.35)] ${i === 1 ? "sm:mt-12" : ""}`}
          >
            <img
              src={f.src}
              alt={f.alt}
              className="w-full aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <figcaption className="absolute bottom-4 left-4 bg-white/92 backdrop-blur rounded-full px-4 py-2 font-mono-x text-[10px] uppercase tracking-[0.15em] text-leafdark">
              {f.label}
            </figcaption>
          </motion.figure>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="font-mono-x text-[11px] uppercase tracking-[0.2em] text-leafdark/70 mt-16 text-center max-w-7xl mx-auto px-5">
          * Sve fotografije su naše — slikano u lokalu, Kneza Miloša bb
        </p>
      </Reveal>
    </section>
  );
};
